import { combineReducers, createAction } from '@reduxjs/toolkit';
import { removeStateFromCookie, removeStateFromSessionStorage } from 'utilities';
import { DESTROY_SESSION } from './actionTypeConstants';
import calculationSlice, { CalculationState } from './slices/calculationSlice';
import calculatorFormSlice, { CalculatorFormState } from './slices/calculatorFormSlice';
import clearSlice, { ClearState } from './slices/clearSlice';
import customerProductsSlice, { CustomerProductsState } from './slices/customerProductsSlice';
import customerSlice, { CustomerState } from './slices/customerSlice';
import errorSlice, { ErrorState } from './slices/errorSlice';
import modalSlice, { ModalState } from './slices/modalSlice';
import pageListSlice, { PageListState } from './slices/pageListSlice';
import placeholderSlice, { PlaceholderState } from './slices/placeholderSlice';
import radioCardSlice, { RadioCardState } from './slices/radioCardSlice';

export interface State {
	pages: PageListState;
	currentRadioState: RadioCardState[];
	calculatorForm: CalculatorFormState;
	calculationState: CalculationState;
	customer: CustomerState;
	customerProducts: CustomerProductsState;
	modal: ModalState;
	error: ErrorState;
	placeholderDefinitions: PlaceholderState;
	isCleared: ClearState;
}

// Combine all reducers.
const appReducer = combineReducers({
	pages: pageListSlice,
	currentRadioState: radioCardSlice,
	calculatorForm: calculatorFormSlice,
	calculationState: calculationSlice,
	customer: customerSlice,
	customerProducts: customerProductsSlice,
	error: errorSlice,
	modal: modalSlice,
	placeholderDefinitions: placeholderSlice,
	clearedState: clearSlice,
});

export const clearPersistedState = createAction(DESTROY_SESSION);

export const rootReducer = (state: State | undefined, action: any) => {
	if (action.type === DESTROY_SESSION) {
		removeStateFromSessionStorage();
		removeStateFromCookie();

		// Reset all slices to their initial state, except preserve isCleared flag as true with count 1
		const emptyState = appReducer(undefined, action);
		return {
			...emptyState,
			clearedState: { isCleared: true, count: 1 },
		};
	}

	return appReducer(state, action);
};
export default rootReducer;
